import * as store from '@/store';

import {feLogger} from '@/buried';

enum RepType {
    Click = 'click',
    Show = 'show',
}

const LogIdMap = {
    initDropMenuTool: '80001.2.291', // 注册更多菜单工具
    clickDropMenuTool: '80001.2.331', // 点击更多菜单工具
    callAPI: '80001.2.292', // 旧的接口调用统计
    error: '80001.2.293', // 错误上报
    call: '80001.2.351', // 新的接口调用统计
};

const report = (reportId: string, data: any = {}, rep_type = RepType.Click) => {
    feLogger({
        rep_id: reportId,
        rep_type,
        rep_params: {...data},
    });
};

export const reportInitDropMenuTool = (data: {
    id: string; // 工具 ID
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};

    report(LogIdMap.initDropMenuTool, {
        ...data,
        docId: docGuid,
    });
};

export const reportClickDropMenuTool = (data: {
    id: string; // 工具 ID
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};

    report(LogIdMap.clickDropMenuTool, {
        ...data,
        docId: docGuid,
    });
};

/**
 * 是否不需要上报【api 调用上报】
 * @param apiName api 名称
 */
const isNoNeedReportCall = (apiName: string) => {
    return [
        'classnames',
        'render'
    ].includes(apiName);
};

export const reportCallToolAPI = (data: {
    id: string; // 工具 ID
    apiName: string; // api 名称
    apiParams: string; // api 参数
}) => {
    if (isNoNeedReportCall(data.apiName)) {
        return;
    }

    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};

    report(LogIdMap.callAPI, {
        ...data,
        docId: docGuid,
    });
};

/**
 * 接口调用上报
 * @param data 上报数据
 */
export const reportCallAPI = (data: {
    id: string; // 工具 ID
    apiName: string; // api 名称
    apiParams: string; // api 参数
    apiPath: string; // api 路径
}, debug = false) => {
    if (isNoNeedReportCall(data.apiName)) {
        return;
    }

    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};
    const {repositoryGuid} = store.getData(store.KEYS.CUR_REPOSITORY) || {};

    const repParams: Record<string, any> = {
        ...data,
        docGuid,
        repositoryGuid,
        terminal: 'pc',
    };

    if (debug) {
        repParams.debug = debug;
    }

    report(LogIdMap.call, repParams);
};

export const reportToolError = (data: {
    id: string; // 工具 ID
    code: number; // 错误码
    apiName?: string; // api 名称
    apiParams?: string; // api 参数
}) => {
    const {docGuid} = store.getData(store.KEYS.CUR_DOCUMENT) || {};

    report(LogIdMap.error, {
        ...data,
        docId: docGuid,
    });
};
